var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Icons",
    filter: "url(#filter0_d_5576_20917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.07812,
    y: 3.43726,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 23.0781,
    cy: 21.4373,
    r: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M13.1686 21.4675C18.4031 19.2448 21.8936 17.7795 23.6401 17.0715C28.6266 15.0501 29.6627 14.699 30.3381 14.6874C30.4866 14.6848 30.8187 14.7207 31.0339 14.8908C31.2155 15.0345 31.2655 15.2286 31.2894 15.3648C31.3133 15.501 31.3431 15.8112 31.3195 16.0537C31.0492 18.8208 29.88 25.536 29.2851 28.6353C29.0334 29.9467 28.5378 30.3864 28.058 30.4295C27.0153 30.523 26.2235 29.7578 25.2136 29.1126C23.6332 28.103 22.7404 27.4745 21.2064 26.4893C19.4336 25.3507 20.5829 24.7249 21.5932 23.7022C21.8576 23.4345 26.4519 19.3617 26.5408 18.9923C26.5519 18.9461 26.5622 18.7738 26.4572 18.6829C26.3523 18.5919 26.1973 18.623 26.0855 18.6478C25.927 18.6828 23.4024 20.3091 18.5116 23.5267C17.795 24.0063 17.1459 24.24 16.5644 24.2277C15.9233 24.2142 14.69 23.8744 13.7732 23.584C12.6487 23.2277 11.755 23.0394 11.8328 22.4344C11.8734 22.1192 12.3187 21.797 13.1686 21.4675Z",
    fill: "url(#paint0_linear_5576_20917)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5576_20917",
    x: 0.278125,
    y: 0.637256,
    width: 45.6,
    height: 45.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5576_20917"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5576_20917",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5576_20917",
    x1: 11.9004,
    y1: 14.6873,
    x2: 11.9004,
    y2: 30.3204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele);
export default __webpack_public_path__ + "static/media/tele.cf075f15a925e8f8357c966d697addeb.svg";
export { ForwardRef as ReactComponent };